<router-outlet />

@if (toast.notification(); as notification) {
  <div class="fixed bottom-4 right-4 z-[1000] pointer-events-none">
    <div
      class="pointer-events-auto min-w-[320px] max-w-[420px] overflow-hidden rounded-[14px] bg-white shadow-[0_8px_32px_rgba(0,0,0,0.14),0_2px_8px_rgba(0,0,0,0.08)] transition-all duration-300 ease-out"
      [attr.role]="notification.type === 'error' ? 'alert' : 'status'"
      [attr.aria-live]="notification.type === 'error' ? 'assertive' : 'polite'"
      [class.opacity-100]="toast.isVisible()"
      [class.translate-y-0]="toast.isVisible()"
      [class.opacity-0]="!toast.isVisible()"
      [class.translate-y-4]="!toast.isVisible()"
    >
      <div
        class="flex items-center justify-between gap-3 px-5 py-4"
        [class.bg-[#FEF2F2]]="notification.type === 'error'"
        [class.text-[#B42318]]="notification.type === 'error'"
        [class.bg-[#ECFDF3]]="notification.type === 'success'"
        [class.text-[#027A48]]="notification.type === 'success'"
      >
        <div class="flex items-center gap-2.5">
          <div
            class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white"
            [class.bg-[#B42318]]="notification.type === 'error'"
            [class.bg-[#027A48]]="notification.type === 'success'"
          >
            <span>x</span>
          </div>
          <p class="text-[15px] font-bold leading-tight">
            {{ toastTitle(notification.type) }}
          </p>
        </div>

        <button
          type="button"
          (click)="closeToast()"
          class="flex h-7 w-7 items-center justify-center rounded-full border text-xs font-bold transition-all hover:text-white"
          [class.border-[#B42318]]="notification.type === 'error'"
          [class.text-[#B42318]]="notification.type === 'error'"
          [class.hover:bg-[#B42318]]="notification.type === 'error'"
          [class.border-[#027A48]]="notification.type === 'success'"
          [class.text-[#027A48]]="notification.type === 'success'"
          [class.hover:bg-[#027A48]]="notification.type === 'success'"
        >
          x
        </button>
      </div>

      <div class="px-5 py-4">
        <p class="text-sm leading-relaxed text-neutral-600">
          {{ notification.message }}
        </p>
      </div>
    </div>
  </div>
}
